





























import { Vue, Component, Prop } from 'vue-property-decorator';

import ReferralExisting from '@/components/icons/ReferralExisting.vue';
import ReferralNew from '@/components/icons/ReferralNew.vue';
import { Typography } from '@/components/atoms';

@Component({
  components: {
    Typography,
    ReferralExisting,
    ReferralNew
  }
})
export default class PreviewReferral extends Vue {
  @Prop(String) readonly type!: 'referring' | 'referred';
  @Prop(Number) readonly value!: number;

  get textTitle() {
    return this[this.type].title;
  }

  get textValue() {
    return this[this.type].value;
  }

  get referring() {
    return {
      title: 'Referring',
      value: `${this.value} ${this.$tc(
        `common.pluralize.coin`,
        this.value || 1
      )}`
    };
  }
  get referred() {
    return {
      title: 'Referred',
      value: this.$t(`${this.tPrefix}.referredValue`, {
        value: this.value
      })
    };
  }

  get tPrefix() {
    return 'referralProgram.campaign';
  }
}
